export default __webpack_public_path__ + "static/media/logo_clipped.cc3de3c6.png";